import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
    content: {
        flexGrow: 1,
        padding: theme.spacing(0),
    },
}))

export default useStyles;